import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, Button, Navbar, Nav, Container, Alert } from 'react-bootstrap';

import routes from '../../features/site/routes';
import UserAuth from '../../components/UserAuth';
import AppContext from '../../core/stores/AppContext';

function Header() {
	const navigate = useNavigate();
	const location = useLocation();
	const [expanded, setExpanded] = useState(false);
	const value = useContext(AppContext);
	const authService = value?.services?.authService;

	const goToHome = () => {
		navigate(routes[0].path);
		setExpanded(false);
	};
	const goToGetQuote = () => {
		navigate(routes[1].path);
		setExpanded(false);
	};
	const goToRetrieveQuote = () => {
		navigate(routes[9].path);
		setExpanded(false);
	};

	// Check if auth bypass is enabled
	const isAuthBypassed = authService?.isAuthBypassEnabled?.() || false;

	return (
		<>
			{/* Development Mode Indicator */}
			{isAuthBypassed && (
				<Alert variant="warning" className="mb-0 text-center py-2">
					🔓 <strong>Development Mode:</strong> Authentication bypassed for local testing
				</Alert>
			)}
			
			<header>
				{/* Desktop Navigation */}
				<Row className='row-ex d-none d-md-flex'>
					<Col xs='12' md='4' className='text-sm-center text-md-start'>
						<img src='https://www.achmea.com.au/wp-content/themes/achmeacom/images/logo.png' onClick={goToHome} height='49' alt='Achmea' title='Achmea' style={{cursor: 'pointer'}} />
					</Col>
					<Col xs='12' md='8' className='text-end d-flex align-items-center justify-content-end'>
						<Button variant={location.pathname === '/' ? 'light':'outline-light'} onClick={goToHome} className='mx-1 form-headline btn-navigation'>HOME</Button>
						<Button variant={location.pathname.includes('/get-quote') ? 'light':'outline-light'} onClick={goToGetQuote} className='mx-1 form-headline btn-navigation'>GET A QUOTE</Button>
						<Button variant={location.pathname.includes('/retrieve-quote') ? 'light':'outline-light'} onClick={goToRetrieveQuote} className='mx-1 form-headline btn-navigation'>RETRIEVE A QUOTE</Button>
						<div className='ms-3'>
							<UserAuth />
						</div>
					</Col>
				</Row>

				{/* Mobile Navigation */}
				<Container className='d-block d-md-none'>
					<Row className='row-ex align-items-center'>
						<Col xs='8' className='text-start'>
							<img src='https://www.achmea.com.au/wp-content/themes/achmeacom/images/logo.png' onClick={goToHome} height='40' alt='Achmea' title='Achmea' style={{cursor: 'pointer'}} />
						</Col>
						<Col xs='4' className='text-end'>
							<Button 
								variant='outline-light' 
								onClick={() => setExpanded(!expanded)}
								className='mobile-menu-btn'
								aria-expanded={expanded}
								aria-label='Toggle navigation'
							>
								<i className={`bi ${expanded ? 'bi-x-lg' : 'bi-list'}`}></i>
							</Button>
						</Col>
					</Row>
					
					{/* Mobile Menu Dropdown */}
					{expanded && (
						<Row className='mobile-menu mt-2'>
							<Col xs='12'>
								<div className='mobile-nav-links'>
									<Button 
										variant={location.pathname === '/' ? 'light':'outline-light'} 
										onClick={goToHome} 
										className='w-100 mb-2 form-headline btn-navigation'
									>
										HOME
									</Button>
									<Button 
										variant={location.pathname.includes('/get-quote') ? 'light':'outline-light'} 
										onClick={goToGetQuote} 
										className='w-100 mb-2 form-headline btn-navigation'
									>
										GET A QUOTE
									</Button>
									<Button 
										variant={location.pathname.includes('/retrieve-quote') ? 'light':'outline-light'} 
										onClick={goToRetrieveQuote} 
										className='w-100 mb-2 form-headline btn-navigation'
									>
										RETRIEVE A QUOTE
									</Button>
									<div className='mt-3 pt-3 border-top'>
										<UserAuth />
									</div>
								</div>
							</Col>
						</Row>
					)}
				</Container>
			</header>
		</>
	);
}

export default Header;
